module.exports = __webpack_public_path__ + "img/tpc-14.14f4e48a.jpg";